export function getEmployeesForAction(action, employees) {
    if (action === 'close_month') {
        return employees.filter(emp => emp.payslip_state === 'verify');
    }
    if (action === 'calculate') {
        return employees.filter(emp => {
            const state = emp.payslip_state;
            return state !== 'done' && state !== 'cancel';
        });
    }
    return employees;
}